import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import Index from "../Index";
import PagesIndex from "../PagesIndex";
import "./RideBooking.css";

const AddRideBooking = (props) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
  };

  const [open, setOpen] = useState(false);
  const [rideBookingId, setRideBookingId] = useState("");

  const { data, handleRideBookingList } = props;

  useEffect(() => {
    if (data) {
      setRideBookingId(data._id);
    } else {
      setRideBookingId("");
    }
  }, [data]);

  const handleClose = () => {
    setOpen(false);
    setRideBookingId("");
  };

  const handleModelOpen = () => {
    setOpen(true);
  };

  const handleAddEditRideBooking = async (values, actions) => {
    const formData = new URLSearchParams();
    formData.append("city", values.city);
    formData.append("bookingNumber", values.bookingNumber);

    if (rideBookingId) {
      formData.append("id", rideBookingId);
    }

    try {
      const res = await PagesIndex.DataService.post(
        PagesIndex.Api.Admin.addEditRideBooking,
        formData
      );

      if (res?.data?.status === 200) {
        PagesIndex.toast.success(res.data.message);
        handleRideBookingList();
        handleClose();
      }
    } catch (error) {
      PagesIndex.toast.error(
        error?.response?.data.message || "Something went wrong"
      );
    } finally {
      actions.setSubmitting(false);
    }
  };

  return (
    <div>
      <Index.Button onClick={handleModelOpen}>
        {props.data ? (
          <img
            alt="img"
            className="Add_Img"
            src={PagesIndex.Svg.blueedit}
          ></img>
        ) : (
          <span className="Add_Btn">Add Ride Booking</span>
        )}
      </Index.Button>

      {open && (
        <Index.Modal
          open={open}
          aria-labelledby="modal-modal-title"
          className="modal"
        >
          <Index.Box
            sx={style}
            className="add-user-modal-inner-main modal-inner"
          >
            <Index.Box className="modal-header" onClick={handleClose}>
              <Index.Typography
                id="modal-modal-title"
                className="modal-title"
                variant="h6"
              >
                {data ? "Update Ride Booking" : "Add Ride Booking"}
              </Index.Typography>
              <img
                alt="IMG"
                src={PagesIndex.Svg.closeblack}
                className="modal-close-icon"
              />
            </Index.Box>

            <Formik
              initialValues={{
                city: data?.city || "",
                bookingNumber: data?.bookingNumber || "",
              }}
              validationSchema={PagesIndex.rideBookingValidation}
              onSubmit={handleAddEditRideBooking}
              enableReinitialize
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                isSubmitting,
              }) => (
                <Form>
                  <Index.Box className="input-box modal-input-box">
                    <Index.FormHelperText className="form-lable">
                      City Name*
                    </Index.FormHelperText>
                    <Index.TextField
                      fullWidth
                      size="small"
                      placeholder="City Name"
                      name="city"
                      value={values.city}
                      onChange={(e) => {
                        let input = e.target.value;

                        input = input.replace(/[^A-Za-z\s]/g, "");

                        if (input.startsWith(" ")) {
                          input = input.trimStart();
                        }

                        const trimmed = input.slice(0, 30);

                        handleChange({
                          target: {
                            name: "city",
                            value: trimmed,
                          },
                        });
                      }}
                      onBlur={handleBlur}
                      error={touched.city && Boolean(errors.city)}
                      helperText={touched.city && errors.city}
                    />
                  </Index.Box>

                  <Index.Box className="input-box modal-input-box">
                    <Index.FormHelperText className="form-lable">
                      Booking Number*
                    </Index.FormHelperText>
                    <Index.TextField
                      fullWidth
                      size="small"
                      placeholder="Booking Number"
                      name="bookingNumber"
                      value={values.bookingNumber}
                      onChange={(e) => {
                        const input = e.target.value;
                        const filtered = input.replace(/[^0-9]/g, "");
                        const trimmed = filtered.slice(0, 11);

                        handleChange({
                          target: {
                            name: "bookingNumber",
                            value: trimmed,
                          },
                        });
                      }}
                      onBlur={handleBlur}
                      error={
                        touched.bookingNumber && Boolean(errors.bookingNumber)
                      }
                      helperText={touched.bookingNumber && errors.bookingNumber}
                    />
                  </Index.Box>

                  <Index.Box className="modal-user-btn-flex">
                    <Index.Box className="discard-btn-main border-btn-main">
                      <Index.Button
                        className="discard-user-btn border-btn"
                        variant="outlined"
                        color="error"
                        onClick={handleClose}
                        sx={{ color: "red" }}
                      >
                        Discard
                      </Index.Button>
                    </Index.Box>
                    <Index.Box className="save-btn-main border-btn-main">
                      <Index.Button
                        className="save-user-btn border-btn"
                        type="submit"
                        disabled={isSubmitting}
                      >
                        <img
                          alt="save"
                          src={PagesIndex.Svg.save}
                          className="user-save-icon"
                        />
                        {data ? "Update" : "Save"}
                      </Index.Button>
                    </Index.Box>
                  </Index.Box>
                </Form>
              )}
            </Formik>
          </Index.Box>
        </Index.Modal>
      )}
    </div>
  );
};

export default AddRideBooking;
